import { GET_MODEL_STRUCTURE_REQUEST_SUCCESS, GET_MODEL_STRUCTURE_REQUEST_FAILURE } from '../constants/get_group_data.constants';

export const getModelStructureRequestSuccess = payload => ({
    type: GET_MODEL_STRUCTURE_REQUEST_SUCCESS, payload,
});

export const getModelStructureRequestFailure = error => ({
    type: GET_MODEL_STRUCTURE_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/get_model_structure.actions.js